import React, { ChangeEvent } from 'react';
import { CheckBoxLabel, InputCheckBox, CheckMarkWrapper, IconWrapper, LabelWrapper } from './CheckBox.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

interface CheckboxPropsType {
    isChecked: boolean;
    isDisabled: boolean;
    handleOnChange: ((e: ChangeEvent<HTMLInputElement>) => void) | (() => void);
    label: React.ReactNode;
    isReversed?: boolean;
}

export const Checkbox = ({
    isChecked,
    handleOnChange,
    isDisabled,
    label,
    isReversed,
}: CheckboxPropsType): React.ReactElement => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { betslipVariant } = configState.componentVariants;

    return (
        <CheckBoxLabel
            isDisabled={isDisabled}
            isReversed={isReversed}
            variant={betslipVariant}
        >
            {betslipVariant === DefaultComponentVariantType.SECONDARY ? <LabelWrapper>{label}</LabelWrapper> : label}
            <>
                <InputCheckBox
                    type='checkbox'
                    disabled={isDisabled}
                    onChange={handleOnChange}
                    checked={isChecked}
                />

                <IconWrapper
                    isChecked={isChecked}
                    isDisabled={isDisabled}
                    isReversed={isReversed}
                >
                    <CheckMarkWrapper isChecked={isChecked} />
                </IconWrapper>
            </>
        </CheckBoxLabel>
    );
};
